module.exports = __webpack_public_path__ + "img/fankui.fa99d552.svg";